import { __read } from "tslib";
import { AppType } from '@office-start/app-gallery-types';
import { isAppPinnable, m365AppPlatformType, } from '@office-start/data-resolver-app-pinning';
import { useAppDefinitions } from '@office-start/m365-apps-service';
import * as React from 'react';
import { appsM365AppId } from './constants';
import { sanitizeImageUrl } from './utils';
/**
 * Custom React Hook responsible for resolving app definition data
 */
export function useAppDefinitionTileData() {
    var appDefinitions = useAppDefinitions();
    var _a = __read(React.useState([]), 2), tileData = _a[0], setTileData = _a[1];
    React.useEffect(function () {
        // Remove apps that have duplicate IDs, with the last app with the duplicated ID wins.
        var m365AppDefinitions = appDefinitions.reduceRight(function (accumulator, value) {
            if (!accumulator.some(function (x) { return x.id === value.id; })) {
                accumulator.unshift(value);
            }
            return accumulator;
        }, []);
        var edges = m365AppDefinitions
            .map(function (appDefinition) {
            // Add the app definition as a new edge.
            return {
                node: {
                    id: appDefinition.id,
                    name: appDefinition.name,
                    accessibleName: appDefinition.name,
                    platformType: m365AppPlatformType,
                    icon: {
                        __typename: 'RemoteImage',
                        src: sanitizeImageUrl(appDefinition.largeImageUrl),
                        isFullBleed: true,
                    },
                    brandingColor: appDefinition.accentColor || '',
                    isPinnable: isAppPinnable(appDefinition.id, AppType.Mos),
                    enablePlatformCommands: true,
                    canBeUnacquired: !!appDefinition.canBeUnacquired,
                    lockedIndex: undefined,
                    pinnedIndex: undefined,
                    canLaunchOut: true,
                    isInUse: false,
                    anchoredIndex: undefined,
                },
            };
        })
            .filter(
        // Remove the app store from the data passed back, since we won't show it as a tile
        function (appDefinition) { return appDefinition.node.id !== appsM365AppId; });
        setTileData(edges);
    }, [appDefinitions]);
    return tileData;
}
//# sourceMappingURL=useAppDefinitionTileData.js.map